/**
 * Analytics Constants
 * this file contains constants of analytics event, its category, action or A/B
 *
 * Naming Convention: SCREAMING_SNAKE_CASE
 * i.e. GTM_EVENT_CONSTANT
 */

export const EVENTS = {
  APP_ERROR: "app-error",
  FLIGHT: "event.flight",
  FLIGHT_NON_INTERACTIVE: "event.noninteractive.flight",
  CONTENT_VIEW: "content-view",
  HEADER: "Header",
  FLIGHT_SEARCH: "flight.search",
  FLIGHT_MODIFY_SEARCH: "flight.modify-search",
  FLIGHT_SEARCH_DETAIL: "flight.search-details",
  FLIGHT_RESULTS: "flight.results",
  FLIGHT_SELECT: "flight.select",
  FLIGHT_DETAILS: "flight.details",
  FLIGHT_BOOKING: "flight.booking",
  FLIGHT_SEARCH_TEALIUM: "flight_search",
  FLIGHT_DETAILS_TEALIUM: "flight_details",
  FLIGHT_PAX_TEALIUM: "flight_travelers",
  FLIGHT_PAYMENT_METHOD_TEALIUM: "flight_payment_method",
  FLIGHT_PAYMENT_TEALIUM: "flight_payment",
  FLIGHT_CONFIRMATION_TEALIUM: "flight_confirmation",
  FLIGHT_HOME: "pwa.flight.home",
  PWA_IS_DOMESTIC: "pwa.flights.isdomestic",
  PWA_FLIGHTS_RESULTS: "pwa.flightevent",
  PWA_FLIGHTS_TRAVELLER_DETAILS: "pwa.flights.travellers.details",
  CHANGE_CURRENCY: "common.change-currency",
  META_FARE_FAMILIES_LOADED: "flights_fareFamilies_popUp",
  META_FARE_FAMILIES_UPGRADED: "flights_fareFamilies_upgraded",
  META_FARE_FAMILIES_SELECTED: "flights_fareFamilies_selected",
  META_FARE_FAMILIES_FAILED: "flights_fareFamilies_error",
  META_FARE_FAMILIES_RELOADED: "flights_fareFamilies_reloaded",
  META_FARE_FAMILIES_SCROLL: "flights_fareFamilies_scroll",
  RECAPTURE_ADDON_ADD: "flights_addon_recapture_added",
  RECAPTURE_ADDON_SKIP: "flights_addon_recapture_skipped",
  RECAPTURE_ADDON_VIEW: "flights_addon_recapture_viewed",
};

export const AVO_EVENTS = {
  FLIGHT_SEARCH: "GA4_flight_search",
  FLIGHT_HOME: "GA4_flight_home",
  FLIGHT_SEARCH_RESULTS: "GA4_flight_search_results",
  FLIGHT_PAX: "GA4_flight_pax",
  FLIGHT_EXTRAS: "GA4_flight_extras",
};

export const AVO_EVENT_CATEGORIES = {
  FLIGHTS_HOME: "Flights Home",
  FLIGHTS_SEARCH: "Flights Search",
  FLIGHTS_SEARCH_RESULTS: "Flights Search Results",
  FLIGHTS_DETAILS: "Flights Details",
  FLIGHTS_TRAVELER_DETAILS: "Flights Traveler Details",
  FLIGHTS_ADDONS: "Flights AddOns",
  META_FARE_FAMILIES: "Meta Fare Families",
};

// TODO: Add missing categories from event utils
export const EVENT_CATEGORIES = {
  FLIGHTS_SEARCH_RESULTS: "Flights Search Results",
  FLIGHTS_PAX: "Flights Pax Details",
  FLIGHTS_UI: "Flights UI",
  API_ERROR_MESSAGES: "API Error Messages",
  FARE_CALENDAR: "fare_calendar",
};

export const EVENT_ACTIONS = {
  FARE_RULES_LOADED: "fare_rules.loaded",
  FLIGHTS_DETAILS: "Flights Details",
  FARE_RULES_LEARN_MORE: "fare_rules_learn_more.clicked",
  FARE_RULES_FAQ: "fare_rules_faq.loaded",
  FLIGHTS_SEARCH_RESULTS: "flight_search_result",
  PWA_FLIGHTS_SEARCH_RESULTS: "pwa_search_results",
  STOP_FILTER: "stops-changed",
  AIRPORT_FILTER: "airports-changed",
  AIRLINE_FILTER: "airlines-changed",
  RESET_ALL_FILTER: "reset-all",
  RESET_PRICE_FILTER: "reset-price",
  OUTBOUND_DEP_CHANGED_FILTER: "outbound-dep-changed",
  INBOUND_DEP_CHANGED_FILTER: "inbound-dep-changed",
  BAGGAGE_FILTER: "Baggage filter",
};

export const EVENT_LABELS = {
  RESET: "reset",
  CHECKED_BAGGAGE: "Checked baggage option - clicked",
};

export const CAMPAIGN_PARAMS = ["utm_source", "utm_medium", "utm_campaign"];

/*
  Moved these to abTestingConstants.ts
  TODO: REMOVE these once all the imports are updated
*/
export const AB_TESTING_FLAGS = {
  EXTRAS_PAGE: "extrasPage",
  META_FARE_FAMILIES: "MetaFareFamilies",
  SERVICE_FEE: "serviceFee",
  HAS_FLEXIBLE_DATES: "hasFlexibleDates",
  NEW_SEARCH_BOX: "newSearchBox",
  URGENCY_DISCLAIMERS: "urgencyDisclaimers",
  MULTI_PNR_FILTER: "flights_multi_pnr_filter_applied",
  SEATS_REMAINING: "flights_seats_remaining",
  SORT_BY_IN_FILTERS: "flights_sortby_in_filters",
  NEARBY_AIRPORTS_BANNER: "flights_nearby_airports",
  SKIP_SERVICE_FEE: "flights_skip_service_fee",
  AD_BANNER_FLAG: "adSponsoredTagVisible",
  AD_BUTLER: "adButlerEnabled",
  FARE_FAMILY_FLOW: "flights_fare_family_flow",
  FARE_FAMILY_FLOW_MWEB: "flight_fare_family_flow",
  FLIGHT_CARD_GROUPING: "flight_card_grouping_disabled",
  EASY_APPLY_FILTERS: "flights_easy_filters",
  RECAPTURING_ADDON: "flights_addon_recapturing",
  PRICE_UPFRONT: "flights_price_upfront",
  ONEWAY_FARE_FAMILY_FLOW: "flight_fare_family_layout",
  META_SEATS_REMAINING: "flights_meta_seats_remaining",
  PREMIUM_ECONOMY_HIGHLIGHT: "flights_premium_economy_fare_dweb",
  DATE_PICKER_PRICES: "flights_date_picker_prices_dweb",
  PRICE_JUMP: "flights_price_jump_web",
  FARE_CALENDAR_VISIBILITY: "flights_fare_calendar_visibility",
};

export const AVO_EVENT_NAMES = {
  // Flights 03 - Search Results
  FLIGHTS_RSP_CARD_VIEWED: "flights_srp_flightCard_viewed",
  FLIGHTS_RSP_CARD_DETAILS_VIEWED: "flights_srp_flightDetails_viewed",
  FLIGHTS_RSP_CARD_SELECTED: "flights_srp_flight_selected",
  FLIGHTS_RSP_MODIFY_SEARCH_CLICKED: "flights_srp_modifySearch_clicked",
  FLIGHTS_RSP_MOIDFY_SEARCH_CANCELLED: "flights_srp_modifySearch_cancelled",
  FLIGHTS_RSP_SORT_BY_OPENED: "flights_srp_sortBy_opened",
  FLIGHTS_RSP_SORT_BY_SELECTED: "flights_srp_sortBy_selected",
  FLIGHTS_RSP_FARE_CALENDAR: "flights_srp_fare_calendar",
  FLIGHTS_RSP_FILTERS: "flights_srp_filters",
  FLIGHTS_RSP_SORT: "flights_srp_sort",
  FLIGHTS_RSP_PAGE_LOADED: "flights_srp_pageLoaded",
  FLIGHTS_RSP_CARD_DETAILS_CLICKED: "flights_srp_flightCard_details_clicked",
  FLIGHTS_RSP_FARE_FAMILIES_UPGRADED: "flights_srp_fareFamilies_upgraded",
  FLIGHTS_RSP_CONDITIONS: "flights_flightConditions",
  FLIGHTS_RSP_CONDITIONS_VIEWED: "flights_flightConditions_viewed",
  FLIGHTS_RSP_CONDITIONS_ACCEPTED: "flights_flightConditions_accepted",
  FLIGHTS_RSP_NEARBY_AIRPORT_CLICK: "flights_srp_nearbyAirports_click",
  FLIGHTS_RSP_NEARBY_AIRPORT_VIEW: "flights_srp_nearbyAirports_view",
  FLIGHTS_SRP_OUTBOUND_CARD_VIEWED: "flights_srp_outbound_flightCard_viewed",
  FLIGHTS_SRP_OUTBOUND_CARD_SELECTED: "flights_srp_outbound_flight_selected",
  FLIGHTS_SRP_INBOUND_CARD_SELECTED: "flights_srp_inbound_flight_selected",
  FLIGHTS_SRP_INBOUND_CARD_VIEWED: "flights_srp_inbound_flightCard_viewed",
  FLIGHTS_SRP_SAME_AIRLINE_FILTER: "flights_srp_same_airline_filter",
  FLIGHTS_GP_FF_ADDED: "flights_gp_frequent_flyer_added",
  FLIGHTS_GP_BAGGAGE_ADDED: "flights_gp_extra_baggage_added",
  FLIGHTS_SRP_AD_AVAILABLE: "flights_srp_ad_available",
  FLIGHTS_SRP_AD_CLICKED: "flights_srp_ad_clicked",
  FLIGHTS_SRP_AD_DISPLAYED: "flights_srp_ad_displayed",
  FLIGHTS_SRP_EASY_APPLY_FILTER: "flights_srp_easy_filters",
  FLIGHTS_SRP_OUTBOUND_FAREFAMILY_SELECTED:
    "flights_srp_outbound_fareFamily_selected",
  FLIGHTS_SRP_INBOUND_FAREFAMILY_SELECTED:
    "flights_srp_inbound_fareFamily_selected",
  FLIGHTS_SRP_QUICK_FILTERS: "flights_srp_quick_filters",
  FLIGHTS_DETAILS_PAGE_LOADED: "flights_dp_pageLoaded",
  FLIGHTS_SRP_FARE_CALENDAR_ACCURACY: "flights_srp_fare_calendar_accuracy",
  TRAVELER_DETAILS_PAGE_CLICKED: "flights_gp_flightDetails_clicked",
  FLIGHTS_ADDON_FLIGHT_DETAILS_CLICKED: "flights_addon_flightDetails_clicked",
};

export const AB_VARIANTS = {
  OFF: "off",
  VARIANT_A: "variant_a",
  VARIANT_B: "variant_b",
  VARIANT_C: "variant_c",
} as const;
